import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../../utility/utility';
import { IconRemoveBundle } from './icons';
import { BundleCardStyled } from './styled';

const BundleCard = ({ bundle, cartLine, isPending, onAdd, onRemove }) => {
  const { t } = useTranslation();
  const isInCart = !!cartLine;

  return (
    <BundleCardStyled>
      <div className="bundle-card-info">
        <div className="bundle-card-name">{bundle.name}</div>
        <div className="bundle-card-subheading">{bundle.subHeading}</div>

        {bundle.discount_percentage > 0 && (
          <div className="bundle-card-strike-wrap">
            Rs. {formatPrice(bundle.total_price)}
            <span className="bundle-card-strike-line" />
          </div>
        )}

        <div className="bundle-card-price-row">
          <div className="bundle-card-price">Rs. {formatPrice(bundle.price)}</div>
          {bundle.discount_percentage > 0 && (
            <div className="bundle-card-chip">{t('Save {{percent}}%', { percent: bundle.discount_percentage })}</div>
          )}
        </div>

        <div className="bundle-card-per-credit">
          {t('Rs. {{price}} per credit', { price: formatPrice(bundle.pricePerCredit) })}
        </div>
      </div>

      <button
        type="button"
        className={isInCart ? 'bundle-card-button bundle-card-button--remove' : 'bundle-card-button'}
        disabled={isPending}
        onClick={() => (isInCart ? onRemove(cartLine) : onAdd(bundle))}
      >
        {isInCart ? (
          <>
            <IconRemoveBundle />
            {t('Remove from Cart')}
          </>
        ) : (
          t('Add to Cart')
        )}
      </button>
    </BundleCardStyled>
  );
};

export default BundleCard;
